import { BtnLabels } from '../interfaces'

export const DEFAULT_BTN_LABELS: BtnLabels = {
  viewCollapsedBtnLabel: 'Expand',
  viewExpandBtnLabel: 'Collapse',
  viewDetailLabel: 'Close'
}
